import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { registerLocaleData, CurrencyPipe } from '@angular/common';
import { ApiModule } from '../api.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { AppRoutingModule } from './app-routing.module';
import { AngularFileUploaderModule } from 'angular-file-uploader';
import { ChartsModule } from 'angular-bootstrap-md';
import { CookieModule } from '@ngx-toolkit/cookie';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PpBreadcrumbsModule } from 'pp-breadcrumbs';
import { SidebarModule } from 'ng-sidebar';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { AlertModalComponent } from 'app/shared/alert-modal/alert-modal.component';
import { ConfirmModalComponent } from 'app/shared/confirm-modal/confirm-modal.component';
import { ExcelExportService } from 'app/shared/xlsx-download/excel-export.service';
import { HomeComponent } from 'app/modules/home/home.component';
import { AuditoriaLogsComponent } from 'app/modules/auditoria/components/auditoria-logs/auditoria-logs.component';
import { PageErrorComponent } from 'app/modules/page-error/page-error.component';
import { SharedModule } from 'app/shared/shared.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TokenInterceptor } from './auth/token.interceptor';
import ptBr from '@angular/common/locales/pt';

// import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { ChartsModule, MDBBootstrapModule, PopoverModule } from 'angular-bootstrap-md';
// import { OrderModule } from 'ngx-order-pipe';

// import { AvaliacoesModule } from 'app/modules/avaliacoes/avaliacoes.module';
// import { CargosModule } from 'app/modules/cargos/cargos.module';
// import { DiagnosticoNr1Module } from 'app/modules/diagnosticonr1/diagnosticonr1.module';
// import { CargosModelosModule } from 'app/modules/cargos-modelos/cargos-modelos.module';
// import { CienciasModule } from 'app/modules/ciencias/ciencias.module';
// import { ClientesModule } from 'app/modules/clientes/clientes.module';
// import { MensagensModule } from 'app/modules/mensagens/mensagens.module';
// import { SelecionadosModule } from 'app/modules/selecionados/selecionados.module';
// import { ServicosModule } from 'app/modules/servicos/servicos.module';
// import { TiposServicosModule } from 'app/modules/tiposServicos/tipos-servicos.module';
// import { UsuariosModule } from 'app/modules/usuarios/usuarios.module';
// import { IntegracoesModule } from 'app/modules/integracoes/integracoes.module';
// import { WebhookModule } from 'app/modules/webhook/webhook.module';

registerLocaleData(ptBr);

@NgModule({
  // imports: [
  //   ApiModule,
  //   AuthModule,
  //   BrowserModule,
  //   HttpClientModule,
  //   ReactiveFormsModule,
  //   FormsModule,
  //   BrowserAnimationsModule,
  //   ChartsModule,
  //   PopoverModule,
  //   AngularFileUploaderModule,
  //   OrderModule,
  //   PpBreadcrumbsModule,
  //   SidebarModule.forRoot(),
  //   ModalModule.forRoot(),
  //   CookieModule.forRoot(),
  //   MDBBootstrapModule.forRoot(),
  //   AvaliacoesModule,
  //   CargosModule,
  //   CargosModelosModule,
  //   CienciasModule,
  //   ClientesModule,
  //   DiagnosticoNr1Module,
  //   IntegracoesModule,
  //   MensagensModule,
  //   SelecionadosModule,
  //   ServicosModule,
  //   TiposServicosModule,
  //   UsuariosModule,
  //   WebhookModule,
  //   SharedModule,
  //   InfiniteScrollModule,
  //   AppRoutingModule,
  // ],
  imports: [
    ApiModule,
    AuthModule, 
    AngularFileUploaderModule,
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ChartsModule,
    PpBreadcrumbsModule,
    SidebarModule.forRoot(),
    ModalModule.forRoot(),
    CookieModule.forRoot(),
    SharedModule,
    InfiniteScrollModule,
    AppRoutingModule, 
    // ReactiveFormsModule,
    // FormsModule,
    // OrderModule,
    // PopoverModule,
    // MDBBootstrapModule.forRoot(),
  ],
  declarations: [
    AppComponent,
    HomeComponent,
    AuditoriaLogsComponent,
    SidebarComponent,
    AlertModalComponent,
    ConfirmModalComponent,
    PageErrorComponent
  ],
  exports: [
    AlertModalComponent
  ],
  providers: [
    CurrencyPipe,
    ExcelExportService,
    SharedModule,
    // OrderModule,
    // AvaliacoesModule,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true // OBRIGATÓRIO para interceptores funcionarem
    },
    { 
      provide: LOCALE_ID, 
      useValue: 'pt' 
    }
  ],
  entryComponents: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
